/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { Button, RadioButton, RadioButtonGroup } from 'carbon-components-react';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { getDmService } from '../../../services/Api';
import { StepCard } from '../../index';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// Definimos um separador para unir/dividir o conteúdo dos dois editores
const SECONDARY_EDITOR_SEPARATOR = '<!-- SECONDARY_EDITOR_SEPARATOR -->';

class BriefingRequestProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      advanced: false,
      idxBriefing: 0,
      listBriefings: [],
      idUrl: null,
      editorState: EditorState.createEmpty(), // Estado único compartilhada
      secondaryEditorState: EditorState.createEmpty(), // Estado para o editor secundário
      createText: '0', // '1' para Sim, '0' para Não. Inicializa como 'Não'.
      primaryEditorContentHTML: '', // HTML único compartilhado
      secondaryEditorContentHTML: '', // Armazena o HTML do editor secundário
    };
  }

  componentWillMount = () => {
    const { dataRequest } = this.props;
    const existDataRequest = Object.prototype.hasOwnProperty.call(dataRequest, 'idGrupo');
    if (existDataRequest) {
      this.loadProductRequest();
      this.implementValuesRequest();
    }
  };

  componentWillUpdate = async () => {
    const { match } = this.props;
    const { idUrl } = this.state;
    if (idUrl !== match.params.id) {
      await this.setState({
        idUrl: match.params.id
      });
    }
  };

  componentDidMount() {
    // O createText já é inicializado no construtor como '0'.
  };

  // Ajuste na lógica para evitar sobrescrever o estado createText do usuário,
  // e garantir que listBriefings mantenha os dados atualizados das props (quantidades etc)
  componentWillReceiveProps(newProps) {
    const { listBriefings: currentListBriefings, createText: currentCreateText, editorState: currentEditorState } = this.state;
    const { dataProduct, dataRequest } = newProps;
    const prevDataRequest = this.props.dataRequest;

    const existDataRequest = Object.prototype.hasOwnProperty.call(dataRequest, 'idGrupo');
    const prevExistDataRequest = Object.prototype.hasOwnProperty.call(prevDataRequest, 'idGrupo');

    // Sempre usamos listSizes das props como base para garantir que temos as quantidades/tamanhos mais recentes
    const { listSizes } = dataProduct;
    let newList = [];

    if (listSizes && listSizes.length > 0) {
      // Clona/Copia os itens das props para garantir estrutura correta
      newList = listSizes.map(item => ({ ...item }));
    }

    let newState = {
      listBriefings: newList
    };

    // Lógica de Inicialização / Preservação do EditorState
    const isFirstLoad = currentListBriefings.length === 0 && newList.length > 0;

    // Determina o createText de entrada vindo do dataRequest (se houver)
    const incomingCreateText = (existDataRequest && dataRequest.criarTexto === 1) ? '1' : '0';
    const prevIncomingCreateText = (prevExistDataRequest && prevDataRequest.criarTexto === 1) ? '1' : '0';

    // Se é o primeiro carregamento ou se dataRequest.criarTexto mudou (e não temos estado local divergente/mais recente?)
    // Precisamos de cuidado para não sobrescrever o que o usuário está digitando se apenas as quantidades mudaram.

    // Se dataRequest acabou de chegar (existDataRequest changed from false to true), devemos carregar dele.
    const dataRequestJustLoaded = existDataRequest && !prevExistDataRequest;

    // Se createText mudou no backend (improvável durante edição, mas possível)
    const createTextBackendChanged = existDataRequest && incomingCreateText !== prevIncomingCreateText;

    if (isFirstLoad || dataRequestJustLoaded || createTextBackendChanged) {
      // Inicialização
      let initialCreateText = incomingCreateText;
      let initialEditorState = EditorState.createEmpty();
      let initialSecondaryEditorState = EditorState.createEmpty();
      let initialPrimaryHtml = '';
      let initialSecondaryHtml = '';

      // Tenta pegar o texto do primeiro item da lista (que veio de dataRequest ou dataProduct)
      if (newList[0] && newList[0].texto) {
        const fullText = newList[0].texto;
        const parts = fullText.split(SECONDARY_EDITOR_SEPARATOR);

        initialPrimaryHtml = parts[0] || '';
        const blocksFromHtmlPrimary = htmlToDraft(initialPrimaryHtml);
        if (blocksFromHtmlPrimary.contentBlocks) {
          const contentStatePrimary = ContentState.createFromBlockArray(blocksFromHtmlPrimary.contentBlocks, blocksFromHtmlPrimary.entityMap);
          initialEditorState = EditorState.createWithContent(contentStatePrimary);
        }

        if (initialCreateText === '1' && parts.length > 1) {
          initialSecondaryHtml = parts[1] || '';
          const blocksFromHtmlSecondary = htmlToDraft(initialSecondaryHtml);
          if (blocksFromHtmlSecondary.contentBlocks) {
            const contentStateSecondary = ContentState.createFromBlockArray(blocksFromHtmlSecondary.contentBlocks, blocksFromHtmlSecondary.entityMap);
            initialSecondaryEditorState = EditorState.createWithContent(contentStateSecondary);
          }
        }
      }

      // Se dataRequest não existe, createText padrão é '0' (pelo construtor/default), 
      // mas se estamos inicializando de um produto salvo que tem texto...
      if (!existDataRequest && isFirstLoad) {
        // Mantemos o padrão '0' se não houver indicação
        // Mas se o usuário já marcou 'Sim' antes? 
        // O estado local createText deve ser preservado se não for um reset total?
        // Neste bloco estamos assumindo reset/first load.

        // Se newList já tem texto, talvez createText deva ser inferido?
        // O backend retorna criarTexto no dataRequest.
      }

      newState = {
        ...newState,
        editorState: initialEditorState,
        secondaryEditorState: initialSecondaryEditorState,
        primaryEditorContentHTML: initialPrimaryHtml,
        secondaryEditorContentHTML: initialSecondaryHtml,
        createText: existDataRequest ? initialCreateText : this.state.createText // Se não tem dataRequest, mantem estado atual (ou '0')
      };

    } else {
      // Atualização (props mudaram, mas não é load inicial nem reset)
      // Preservamos o editorState e createText do state atual
      // Apenas listBriefings (newList) foi atualizado acima, o que é correto para atualizar quantidades.

      // EXCEÇÃO: Se o usuário trocou o CreateText via props (se viesse de fora), mas aqui createText é local ou via dataRequest.
      // E verificação do "Zero ou Um" (se o usuário clicou no radio button, isso chama setState, não componentWillReceiveProps, mas setState trigger re-render).
      // Se dataRequest mudou createText, já tratamos no if acima.

      // O bug "Zero ou Um" era quando newList mudava/era recriada e perdíamos o state.
      // Aqui, como preservamos this.state.editorState (não incluindo-o no newState), ele se mantém.
    }

    if (Object.keys(newState).length > 0) {
      this.setState(newState);
    }
  }

  loadProductRequest = async () => {
    const { dataRequest } = this.props;
    const { idProduto } = dataRequest;
    try {
      const data = await getDmService(`/Pedido/GetNomeProduto/?grupo=${dataRequest.idGrupo}`);
      const idsSearch = data.find(item => parseInt(item.id, 10) === parseInt(idProduto, 10));
      const productRequest = { id: idsSearch.id, label: idsSearch.nome };
      this.setState({
        productRequest
      });
    } catch (error) {
      console.log(error);
    }
  };

  implementValuesRequest = () => {
    const { dataRequest } = this.props;
    const existDataRequest = Object.prototype.hasOwnProperty.call(dataRequest, 'idGrupo');
    if (existDataRequest) {
      const list = dataRequest.detalhes.map(item => ({
        id: item.id,
        texto: item.briefing
      }));
      const initialCreateText = dataRequest.criarTexto === 1 ? '1' : '0';

      let editorState = EditorState.createEmpty();
      let secondaryEditorState = EditorState.createEmpty();
      let primaryHtml = '';
      let secondaryHtml = '';

      if (list[0] && list[0].texto) {
        const fullText = list[0].texto;
        const parts = fullText.split(SECONDARY_EDITOR_SEPARATOR);

        primaryHtml = parts[0] || '';
        const blocksFromHtmlPrimary = htmlToDraft(primaryHtml);
        if (blocksFromHtmlPrimary.contentBlocks) {
          const contentStatePrimary = ContentState.createFromBlockArray(blocksFromHtmlPrimary.contentBlocks, blocksFromHtmlPrimary.entityMap);
          editorState = EditorState.createWithContent(contentStatePrimary);
        }

        if (initialCreateText === '1' && parts.length > 1) {
          secondaryHtml = parts[1] || '';
          const blocksFromHtmlSecondary = htmlToDraft(secondaryHtml);
          if (blocksFromHtmlSecondary.contentBlocks) {
            const contentStateSecondary = ContentState.createFromBlockArray(blocksFromHtmlSecondary.contentBlocks, blocksFromHtmlSecondary.entityMap);
            secondaryEditorState = EditorState.createWithContent(contentStateSecondary);
          }
        }
      }

      this.setState({
        listBriefings: list,
        editorState,
        secondaryEditorState,
        primaryEditorContentHTML: primaryHtml,
        secondaryEditorContentHTML: secondaryHtml,
        createText: initialCreateText,
      });
    }
  };

  renderCreateText = () => {
    const { createText } = this.state;
    const { onCreateTextChange } = this.props;
    return (
      <React.Fragment>
        <div className='radio-input'>
          <p className='color-red'><b>Este pedido envolve a criação ou revisão de texto?</b></p>
          <div className="inline-radio">
            <RadioButtonGroup
              legendText="Radio button heading"
              name="CriarTexto"
              valueSelected={createText !== undefined && createText !== null ? String(createText) : undefined}
              onChange={value => {
                console.log('Radio button changed to:', value); // DEBUG: Verifique o valor aqui
                this.setState({ createText: value }); // Salva como string '1' ou '0'
                if (onCreateTextChange) {
                  onCreateTextChange(value); // Passa string para o pai
                }
                // Limpa o editor secundário se o usuário mudar para 'Não'
                if (value === '0') {
                  this.setState({
                    secondaryEditorState: EditorState.createEmpty(),
                    secondaryEditorContentHTML: ''
                  });
                }
              }}
            >
              <RadioButton
                value="1"
                labelText="Sim"
                id="radio-1"
              />
              <RadioButton
                value="0"
                labelText="Não"
                id="radio-2"
              />
            </RadioButtonGroup>
          </div>
        </div>
      </React.Fragment>
    );
  };

  renderDescription = () => {
    const { dataProduct, dataRequest, isKit } = this.props;
    const { productSave } = dataProduct;
    const { listBriefings, productRequest, createText } = this.state;
    const nameProduct =
      productSave && productSave.label
        ? productSave.label
        : productRequest
          ? productRequest.label
          : '';

    // A descrição deve mostrar o texto combinado se createText for '1'
    const displayBriefings = listBriefings.map(item => {
      if (createText === '1' && item.texto && item.texto.includes(SECONDARY_EDITOR_SEPARATOR)) {
        const [primary, secondary] = item.texto.split(SECONDARY_EDITOR_SEPARATOR);
        return {
          ...item,
          texto: `<div>${primary}</div><div><strong>Informações Adicionais:</strong></div><div>${secondary}</div>`
        };
      }
      return item;
    });

    return (
      <React.Fragment>
        {dataRequest.criarTexto === 1 && (
          <p className="description">
            <strong>Este pedido envolve a criação ou revisão de texto</strong>
          </p>
        )}
        {displayBriefings.length > 0 && !isKit &&
          displayBriefings.map((item, index) => (
            <p key={index} className="description">
              <strong>{`${nameProduct}  ${item.texto ? ' - ' : ''}`}</strong>
              <div dangerouslySetInnerHTML={{ __html: displayBriefings[index].texto }} />
            </p>
          ))}
        {displayBriefings.length > 0 && isKit && (
          <p key={0} className="description">
            <strong>{`${nameProduct} ${displayBriefings[0].texto ? ' - ' : ''}`}</strong>
            <div dangerouslySetInnerHTML={{ __html: displayBriefings[0].texto }} />
          </p>
        )}
      </React.Fragment>
    );
  };

  advance = async () => {
    const { saveStep } = this.props;
    const { listBriefings, createText, primaryEditorContentHTML, secondaryEditorContentHTML } = this.state;
    const { isKit, dataProduct } = this.props;
    const { productSave } = dataProduct;

    const updatedListBriefings = [...listBriefings];

    // Determina se o produto é do tipo "Texto"
    const productInvolvesText = productSave && productSave.tipoUso && productSave.tipoUso.includes("Texto");

    if (isKit) {
      let combinedContent = primaryEditorContentHTML || '';
      if (!productInvolvesText && createText === '1') {
        combinedContent += SECONDARY_EDITOR_SEPARATOR + secondaryEditorContentHTML;
      }
      updatedListBriefings.forEach(item => {
        item.texto = combinedContent;
      });
    } else if (updatedListBriefings.length > 0) {
      updatedListBriefings.forEach((item) => {
        let combinedContent = primaryEditorContentHTML || '';
        if (!productInvolvesText && createText === '1') {
          combinedContent += SECONDARY_EDITOR_SEPARATOR + secondaryEditorContentHTML;
        }
        item.texto = combinedContent;
      });
    }

    const dataToSave = {
      listSizes: updatedListBriefings,
      // O valor de criarTexto só é relevante se o produto NÃO for do tipo "Texto"
      criarTexto: !productInvolvesText ? (createText === '1' ? 1 : 0) : 0,
    };

    await saveStep(
      dataToSave,
      'briefing'
    );
    await this.stepCardRef.toggleContent();
  };

  cancel = () => {
    this.stepCardRef.toggleContent();
  };

  briefingOk = () => {
    const { dataProduct } = this.props;
    const { createText, primaryEditorContentHTML, secondaryEditorContentHTML } = this.state;
    const { dataFilters, productSave } = dataProduct || {};

    // Determina se o produto é do tipo "Texto"
    const productInvolvesText = productSave && productSave.tipoUso && productSave.tipoUso.includes("Texto");

    // Se o briefing for opcional, sempre retorna true
    if (dataFilters && !dataFilters.briefing) {
      return true;
    }

    // Verifica se o editor primário tem conteúdo (ignorando <p></p> vazio)
    const primaryHasContent = primaryEditorContentHTML && primaryEditorContentHTML.trim() !== '<p></p>';

    // Se o produto for do tipo "Texto", apenas o editor primário é relevante para validação
    if (productInvolvesText) {
      return primaryHasContent;
    }

    // Se o produto NÃO for do tipo "Texto", a lógica do radio button se aplica
    if (createText === '1') {
      // Se "Sim" for selecionado, o editor secundário também é relevante.
      // Consideramos OK se o primário OU o secundário tiverem conteúdo.
      const secondaryHasContent = secondaryEditorContentHTML && secondaryEditorContentHTML.trim() !== '<p></p>';
      return primaryHasContent || secondaryHasContent;
    } else {
      // Se "Não" for selecionado, apenas o editor primário é relevante.
      return primaryHasContent;
    }
  }

  addTag = async (tag) => {
    const { primaryEditorContentHTML } = this.state;

    let txtTag = '';
    if (tag === '<CHAMADA>') {
      txtTag = ' <p>Chamada</p> ';
    } else if (tag === '<PRAZO>') {
      txtTag = ' <p>Tenha + prazo pra pagar</p> ';
    } else if (tag === '<DESCONTOS_OFERTAS>') {
      txtTag = ' <p>Descontos e ofertas exclusivas</p> ';
    } else if (tag === '<BAIXE_APP>') {
      txtTag = ' <p>whatsapp + qrcode</p> ';
    } else if (tag === '<AUMENTO_LIMITE>') {
      txtTag = ' <p>Aumento de limite</p> ';
    } else if (tag === '<RAPIDA_APROVACAO>') {
      txtTag = ' <p>Rápida aprovação</p> ';
    } else if (tag === '<CARTAO_ADICIONAL>') {
      txtTag = ' <p>Cartão adicional</p> ';
    } else {
      txtTag = ' <p>Parcelamento em X</p> ';
    }

    // Adiciona a tag ao conteúdo HTML atual do editor primário
    const newHtmlContent = primaryEditorContentHTML + txtTag;

    // Converte o novo HTML para EditorState
    const blocksFromHtml = htmlToDraft(newHtmlContent);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const newEditorState = EditorState.createWithContent(contentState);

    await this.setState({
      editorState: newEditorState,
      primaryEditorContentHTML: newHtmlContent,
    });
  };

  renderOptional = () => {
    const { dataProduct } = this.props;
    const { dataFilters } = dataProduct;
    if (dataFilters && !dataFilters.briefing) {
      return <span className="optional"> (opcional)</span>;
    }
    return '';
  };

  entityMapper = (entity) => {
    if (!entity) {
      return "";
    }
    if (entity.type === "DIV") {
      return `<div>${entity.data.innerHTML}</div>`;
    }
    if (entity.type === "TABLE") {
      return `<table>${entity.data.innerHTML}</table>`;
    }
    if (entity.type === "TBODY") {
      return `<tbody>${entity.data.innerHTML}</tbody>`;
    }
    if (entity.type === "TR") {
      return `<tr>${entity.data.innerHTML}</tr>`;
    }
    if (entity.type === "TH") {
      return `<th>${entity.data.innerHTML}</th>`;
    }
    if (entity.type === "TD") {
      return `<td>${entity.data.innerHTML}</td>`;
    }
    if (entity.type === "P") {
      return `<p>${entity.data.innerHTML}</p>`;
    }
    if (entity.type === "STYLE") {
      return `<style>${entity.data.innerHTML}</style>`;
    }
    return "";
  }

  onPrimaryEditorStateChange = (editorState) => {
    const primaryEditorHTML = draftToHtml(
      convertToRaw(editorState.getCurrentContent()),
      null,
      false,
      this.entityMapper
    );

    this.setState({
      editorState,
      primaryEditorContentHTML: primaryEditorHTML,
    });
  };

  onSecondaryEditorStateChange = (secondaryEditorState) => {
    const secondaryEditorHTML = draftToHtml(
      convertToRaw(secondaryEditorState.getCurrentContent()),
      null,
      false,
      this.entityMapper
    );
    this.setState({
      secondaryEditorState,
      secondaryEditorContentHTML: secondaryEditorHTML,
    });
  };

  render() {
    const { advanced, listBriefings, productRequest, editorState, secondaryEditorState, createText } = this.state;
    const { disabledCard, isFinished, dataProduct, isKit } = this.props;
    const { productSave } = dataProduct;

    const nameProduct =
      productSave && productSave.label
        ? productSave.label
        : productRequest
          ? productRequest.label
          : '';

    // Determina se o produto envolve texto para o label do editor principal E para a visibilidade do radio button/segundo editor
    const productInvolvesText = productSave && productSave.tipoUso && productSave.tipoUso.includes("Texto");

    return (
      <StepCard
        onRef={ref => {
          this.stepCardRef = ref;
        }}
        title="Briefing"
        optional={this.renderOptional()}
        description={this.renderDescription()}
        isFinished={isFinished}
        onToogle={advanced}
      >
        <div>
          <div>
            {/* O radio button só será renderizado se o produto NÃO for do tipo "Texto" */}
            {!productInvolvesText && this.renderCreateText()}
          </div>
          {/* Editor Secundário (Texto): Mostra ANTES do Arte se o produto NÃO for do tipo "Texto" E "Sim" for selecionado */}
          {!productInvolvesText && createText === '1' && (
            <div className="bx--row v-md-margin">
              <div className="bx--col-xs-12 bx--col-md-12">
                <label className="bx--label">Briefing de Texto</label>
                <p className="description">
                  Forneça detalhes adicionais, referências, ou qualquer outra informação que ajude na criação ou revisão do texto.
                </p>
                <Editor
                  editorState={secondaryEditorState} // Vincula ao estado do editor secundário
                  editorClassName="border-editor"
                  onEditorStateChange={this.onSecondaryEditorStateChange}
                />
              </div>
            </div>
          )}

          {isKit ? (
            <div key={0}>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-12">
                  <label className="bx--label">{`${nameProduct}`}</label>
                  <Editor
                    editorState={editorState} // Editor Primário
                    editorClassName="border-editor"
                    onEditorStateChange={this.onPrimaryEditorStateChange}
                  />
                </div>
              </div>
              {/* As tags são exibidas se não estiver desabilitado, se o produto NÃO for do tipo "Texto" E se o radio button de criação de texto estiver ativo ('1') */}
              {!disabledCard && !productInvolvesText && createText === '1' && (
                <div className="bx--row flexible sm-margin">
                  <div className="tags bx--col-xs-12 v-md-margin">
                    <button className="button button--clear" onClick={() => this.addTag('<CHAMADA>')} type="submit"><span className="bx--tag bx--tag--ibm">Chamada</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<PRAZO>')} type="submit"><span className="bx--tag bx--tag--ibm">+ prazo pra pagar</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<DESCONTOS_OFERTAS>')} type="submit"><span className="bx--tag bx--tag--ibm">Descontos e ofertas exclusivas</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<BAIXE_APP>')} type="submit"><span className="bx--tag bx--tag--ibm">whatsapp + qrcode</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<PARCELAMENTO>')} type="submit"><span className="bx--tag bx--tag--ibm">Parcelamento</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<AUMENTO_LIMITE>')} type="submit"><span className="bx--tag bx--tag--ibm">Aumento de limite</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<CARTAO_ADICIONAL>')} type="submit"><span className="bx--tag bx--tag--ibm">Cartão adicional</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<RAPIDA_APROVACAO>')} type="submit"><span className="bx--tag bx--tag--ibm">Rápida aprovação</span></button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-12">
                  <label className="bx--label">
                    Briefing de {productInvolvesText ? " Texto" : " Arte"}
                  </label>
                  {/* Descrição do briefing principal */}
                  {productInvolvesText ? (
                    <p className="description">
                      Criação de conteúdos do zero? Revisão de um conteúdo já feito?
                      Conceito criativo/slogan para campanha? Explique e forneça as informações que considera
                      relevantes para esse trabalho.
                    </p>
                  ) : (
                    <p className="description">
                      Descreva o que você precisa, com informações relevantes para a criação: objetivo, público,
                      canal onde o texto será divulgado, expectativa textual (tom de voz, estilo, palavras-chave e
                      se deve seguir alguma identidade textual, por exemplo)
                    </p>
                  )}
                  <Editor
                    editorState={editorState} // Editor Primário
                    editorClassName="border-editor"
                    onEditorStateChange={this.onPrimaryEditorStateChange}
                  />
                </div>
              </div>
              {/* As tags são exibidas se não estiver desabilitado, se o produto NÃO for do tipo "Texto" E se o radio button de criação de texto estiver ativo ('1') */}
              {!disabledCard && !productInvolvesText && (
                <div className="bx--row flexible sm-margin">
                  <div className="tags bx--col-xs-12 v-md-margin">
                    <button className="button button--clear" onClick={() => this.addTag('<CHAMADA>')} type="submit"><span className="bx--tag bx--tag--ibm">Chamada</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<PRAZO>')} type="submit"><span className="bx--tag bx--tag--ibm">+ prazo pra pagar</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<DESCONTOS_OFERTAS>')} type="submit"><span className="bx--tag bx--tag--ibm">Descontos e ofertas exclusivas</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<BAIXE_APP>')} type="submit"><span className="bx--tag bx--tag--ibm">whatsapp + qrcode</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<PARCELAMENTO>')} type="submit"><span className="bx--tag bx--tag--ibm">Parcelamento</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<AUMENTO_LIMITE>')} type="submit"><span className="bx--tag bx--tag--ibm">Aumento de limite</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<CARTAO_ADICIONAL>')} type="submit"><span className="bx--tag bx--tag--ibm">Cartão adicional</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<RAPIDA_APROVACAO>')} type="submit"><span className="bx--tag bx--tag--ibm">Rápida aprovação</span></button>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Editor Secundário: Mostra apenas se o produto NÃO for do tipo "Texto" E se "Sim" for selecionado no radio button */}


          <div className="bx--row">
            <div className="bx--col-xs-12 bx--col-sm-6 v-md-margin">
              <Button
                onClick={() => {
                  this.advance(); // Chama advance para salvar
                }}
                disabled={!this.briefingOk()} // Desabilita se a validação não passar
              >
                Salvar Briefing
              </Button>
              <Button kind="ghost" className="h-sm-margin" onClick={this.cancel}>
                Cancelar
              </Button>
            </div>
          </div>
        </div>
      </StepCard>
    );
  }
}

export default BriefingRequestProduct;



// WEBPACK FOOTER //
// ./src/components/agency/requests/BriefingRequestProduct.js